function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M6.8,43.3l63.4-42c2.5-1.6,6.4-1.6,8.9,0l63.4,42c3.8,2.5,3.8,6.6,0,9.1L134,58c-12.5-19.7-34.5-32.7-59.4-32.7 c-25,0-46.9,13.1-59.4,32.7l-8.5-5.6C3,49.9,3,45.7,6.8,43.3z M74.6,42.8c-18.9,0-35.4,10-44.8,24.8l14.6,9.7 c6.2-10.2,17.3-17,30.1-17c12.7,0,23.9,6.8,30.1,17l14.6-9.7C110.1,52.8,93.5,42.8,74.6,42.8z M74.6,77.9c-6.6,0-12.4,3.7-15.5,9.1 l9.8,6.4c1.6,1.3,3.5,2.1,5.7,2.1s4.2-0.8,5.7-2.1l9.8-6.4C87.2,81.7,81.3,77.9,74.6,77.9z"
});

const SvgKlaviyo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 150 95.5",
  style: {
    enableBackground: "new 0 0 150 95.5"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 1503.416,
  y1: 3552.7449,
  x2: 1503.416,
  y2: 3417.8276,
  gradientTransform: "matrix(0.7071 0 0 0.7071 -988.4218 -2416.646)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFE01E"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1373,
  style: {
    stopColor: "#CADD32"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3103,
  style: {
    stopColor: "#8FD848"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4774,
  style: {
    stopColor: "#5ED55B"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.634,
  style: {
    stopColor: "#37D269"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7779,
  style: {
    stopColor: "#1CD073"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9044,
  style: {
    stopColor: "#0BCF7A"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#05CE7C"
  }
})), _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKlaviyo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/klaviyo.c39a0bc8.svg";
export { ForwardRef as ReactComponent };